import { useTranslation } from '@invision/core';
import React from 'react';
import { Typography } from '../../format/Typography';
import ErrorIcon from '../../icons/exclamation-circle-outline.svg';
import { LinkButton } from '../../inputs/Button';
import { Box } from '../../layout/Box';
import { FillAndCenter } from '../../layout/FillAndCenter';
import { Icon } from '../Icon';
import { ErrorBoundaryTemplate } from './errorBoundary.interfaces';

export function AppErrorBoundaryTemplate({
  resetErrorBoundary
}: ErrorBoundaryTemplate) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        height: '100vh'
      }}
    >
      <FillAndCenter>
        <Icon
          color="error"
          style={{ fontSize: '6rem', width: '6rem' }}
          glyph={ErrorIcon}
        />
        <Box
          sx={{
            p: 1
          }}
        >
          <Typography color="error" variant="h1">
            {t('There was an error loading the application')}
          </Typography>
        </Box>
        <Typography variant="body1">
          <LinkButton onClick={resetErrorBoundary}>{t('Try Again')}</LinkButton>
        </Typography>
      </FillAndCenter>
    </Box>
  );
}
